import { render, staticRenderFns } from "./server-file.vue?vue&type=template&id=9bfc5a90&"
import script from "./server-file.vue?vue&type=script&lang=js&"
export * from "./server-file.vue?vue&type=script&lang=js&"
import style0 from "./server-file.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports